
export interface KarmaClaimConfigDetails {
  points: number;
  title: string;
  activityType: 'login' | 'activity' | 'referral';
  description: string;
}

export const karmaClaimConfig: Record<'daily' | 'weekly' | 'referral', KarmaClaimConfigDetails> = {
  daily: {
    points: 10,
    title: "Daily Login",
    activityType: 'login',
    description: 'Daily login bonus',
  },
  weekly: {
    points: 25,
    title: "Weekly Activity",
    activityType: 'activity',
    description: 'Weekly activity bonus',
  },
  referral: {
    points: 25,
    title: "Friend Referral",
    activityType: 'referral',
    description: 'Friend referral bonus',
  },
};

